<template>
  <FormulateForm
    v-model="passwordForm"
    :form-errors="error"
    @submit="updatePassword"
    class="accent-form"
  >
    <p v-if="success" class="success">{{ success }}</p>
    <FormulateInput
      type="password"
      class="span-full"
      name="Neues Passwort"
      label="Passwort (mind. 8 Zeichen)"
      validation="required|min:8"
    />
    <FormulateInput
      type="password"
      class="span-full"
      name="Neues Passwort_confirm"
      label="Passwort wiederholen"
      validation="required|confirm"
    />
    <FormulateInput
      type="submit"
      class="span-full"
      :value="saving"
      label="Speichern"
    />
  </FormulateForm>
</template>

<script>
import AuthService from "@/services/authentication";

export default {
  name: "ResetPasswordForm",
  data() {
    return {
      saving: false,
      success: undefined,
      error: [],
      passwordForm: {
        "Neues Passwort": null,
        "Passwort Wiederholung": null,
      },
    };
  },
  methods: {
    async updatePassword() {
      this.saving = true;
      this.success = undefined;
      try {
        this.error = [];
        await AuthService.resetPassword({
          new: this.passwordForm["Neues Passwort"],
          new_confirm: this.passwordForm["Neues Passwort_confirm"],
          token: this.$route.params.token,
        });
        this.passwordForm = {
          "Neues Passwort": null,
          "Passwort Wiederholung": null,
        };
        this.success = "Passwort erfolgreich zurückgesetzt.";
        if (this.$listeners.submit) {
          this.$listeners.submit();
        }
      } catch (e) {
        this.error = ["Passwort zurücksetzen fehlgeschlagen!"];
        console.error(e);
      }
      this.saving = false;
    },
  },
};
</script>
<style scoped>
::v-deep .formulate-input-element--password .toggle {
  @apply top-2;
}
</style>
